import { TuiRoot } from '@taiga-ui/core';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { tuiValidationErrorsProvider } from '@taiga-ui/kit';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TuiRoot],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [
    tuiValidationErrorsProvider({
      required: 'This field is required',
      email: 'Enter a valid email',
      passwordPattern: 'Password must contain at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character',
    }),
  ],
})
export class AppComponent {
  title = 'Foursquare Elections';
}
